export const obtenerPorcentajeDosValores = (numero, total) => {

    if (numero <= 0) {
        return 0
    }

    let por = (numero * 100) / total
    return por.toFixed(0)
}